// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"30":"c348dbff","821":"d1f1dbfd"}[chunkId] + ".css";
};